import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { PageForm } from '@/components/forms/PageForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function PagesEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const [pageId, setPageId] = useState<number | null>(null)
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!id) {
      navigate('/content-management/pages', { replace: true })
      return
    }

    const parsedId = Number(id)
    if (Number.isNaN(parsedId)) {
      navigate('/content-management/pages', { replace: true })
      return
    }

    setPageId(parsedId)
    setIsValidating(false)
  }, [id, navigate])

  const handleSuccess = () => {
    navigate('/content-management/pages')
  }

  const handleCancel = () => {
    navigate('/content-management/pages')
  }

  if (isValidating || pageId === null) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Page</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update page content and settings.
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <PageForm pageId={pageId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


